<template>
  <div class="act-document">
    <div class="act-title">
      {{
        $getVisibleNames(
          "manual.acta_de_comite",
          false,
          "Acta de Comité"
        ).toUpperCase()
      }}
    </div>
    <div class="act-content">
      <div class="act-section">
        <div class="info-grid">
          <div v-if="!selectedActTypeIsInstitutional" class="info-row">
            <div class="info-label1">
              {{ $getVisibleNames("mesh.career", false, "Programa") }}:
            </div>
            <div class="info-value">{{ career ? career.name : "" }}</div>
          </div>
          <div v-if="!selectedActTypeIsInstitutional" class="info-row">
            <div class="info-label1">
              {{
                $getVisibleNames(
                  "mesh.egressprofile",
                  false,
                  "Perfil de Egreso"
                )
              }}:
            </div>
            <div class="info-value">
              <span class="link-text" @click="redirectEgressProfile">
                {{ egressProfile ? egressProfile.name : "" }}
              </span>
            </div>
          </div>
          <div v-if="!selectedActTypeIsInstitutional" class="info-row">
            <div class="info-label1">
              {{ $getVisibleNames("mesh.campus", false, "Sede") }}:
            </div>
            <div class="info-value">{{ campus ? campus.name : "" }}</div>
          </div>
          <div v-if="selectedActTypeIsInstitutional" class="info-row">
            <div class="info-label1">
              {{ $getVisibleNames("manual.codeact", false, "Código de Acta") }}:
            </div>
            <div class="info-value">{{ act.code }}</div>
          </div>
          <div class="info-row">
            <div class="info-label1">
              {{ $getVisibleNames("mesh.period", false, "Período") }}:
            </div>
            <div class="info-value">{{ getPeriod }}</div>
          </div>
          <div class="info-row">
            <div class="info-label1">{{ $t("toolbar.acts.createdBy") }}:</div>
            <div class="info-value">{{ creatorLabel }}</div>
          </div>
        </div>

        <!-- <h4 class="subsection-title">
          {{ $t("toolbar.acts.guests").toUpperCase() }}
        </h4> -->
        <div class="support-button mb-2">
          <ButtonMedium
            v-if="allows_crud"
            :tooltip_text="``"
            :text_button="$t('toolbar.acts.manageAttendees')"
            :click_button="() => $bvModal.show('modal-users')"
            :icon="'file-check'"
            :variant="'primary'"
            :custom_class="`mt-1`"
          >
          </ButtonMedium>
          <!-- <b-button
            v-if="allows_crud"
            class="act-button"
            size="sm mt-1"
            @click="$bvModal.show('modal-users')"
          >
            <b-icon-file-plus></b-icon-file-plus>Gestionar Asistentes
          </b-button> -->
          <ButtonMedium
            v-if="allows_crud"
            :tooltip_text="``"
            :text_button="$t('toolbar.acts.addExternalAttendee')"
            :click_button="() => $bvModal.show('modal-support')"
            :icon="'plus'"
            :variant="'primary'"
            :custom_class="`mt-1 ml-3`"
          >
          </ButtonMedium>
          <!-- <b-button
            v-if="allows_crud"
            class="act-button"
            size="sm mt-1 ml-3"
            @click="$bvModal.show('modal-support')"
          >
            <b-icon-file-plus></b-icon-file-plus>Agregar Asistente Externo
          </b-button> -->
        </div>
        <div class="table-container">
          <b-table-simple
            responsive
            hover
            v-if="actUsers.length > 0"
            class="formal-table"
          >
            <b-thead class="formal-thead">
              <b-tr>
                <b-th>{{ $t("toolbar.acts.identifier") }}</b-th>
                <b-th>{{ $t("toolbar.acts.name") }}</b-th>
                <b-th>{{ $t("toolbar.acts.email") }}</b-th>
                <b-th>{{ $t("toolbar.acts.position") }}</b-th>
                <b-th>{{ $t("toolbar.acts.otherInformation") }}</b-th>
                <b-th>{{ $t("toolbar.acts.user") }}</b-th>
                <b-th>{{ $t("toolbar.acts.canEditAct") }}</b-th>
                <b-th>{{ $t("toolbar.acts.attended") }}</b-th>
                <b-th v-if="allows_crud">{{
                  $t("reusable.common.actions")
                }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody
              ><b-tr v-for="user in actUsers" :key="user.id">
                <b-td>
                  <span
                    v-if="user.identifier_type != null && user.identifier != ''"
                  >
                    {{ getIdentifierType(user.identifier_type)
                    }}<template v-if="user.identifier_type != null"
                      >:
                    </template>
                    {{ user.identifier }}
                  </span>
                </b-td>
                <b-td>
                  {{ user.first_name + " " + user.last_name }}
                </b-td>
                <b-td>
                  {{ user.email }}
                </b-td>
                <b-td>
                  {{ user.occupation }}
                </b-td>
                <b-td>
                  {{ user.other_data }}
                </b-td>
                <b-td>
                  <strong class="ml-2" v-if="user.professional == null">{{
                    $t("toolbar.acts.external")
                  }}</strong
                  ><strong v-else>{{ $t("toolbar.acts.internal") }}</strong>
                </b-td>
                <b-td>
                  <b-icon
                    v-if="user.can_edit"
                    icon="check"
                    scale="1.5"
                    variant="success"
                  ></b-icon>
                  <b-icon v-else icon="x" scale="1.5" variant="danger"></b-icon>
                </b-td>
                <b-td>
                  <b-icon
                    v-if="user.assisted"
                    icon="check"
                    scale="1.5"
                    variant="success"
                  ></b-icon>
                  <b-icon v-else icon="x" scale="1.5" variant="danger"></b-icon>
                </b-td>
                <b-td v-if="allows_crud">
                  <div v-if="allows_crud">
                    <ButtonSmall
                      :tooltip_text="$t('toolbar.acts.editAttendee')"
                      :text_button="``"
                      :click_button="
                        () => $bvModal.show(`modal-support-${user.id}`)
                      "
                      :icon="'square'"
                      :variant="'none'"
                      :custom_class="``"
                    >
                    </ButtonSmall>
                    <!-- <b-button
                      class="act-button ml-1 mb-1"
                      size="sm "
                      v-b-tooltip.v-secondary.noninteractive="
                        $t('toolbar.acts.editAttendee')
                      "
                      @click="$bvModal.show(`modal-support-${user.id}`)"
                    >
                      <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
                    </b-button> -->
                    <ButtonSmall
                      :tooltip_text="$t('toolbar.acts.removeAttendee')"
                      :text_button="``"
                      :click_button="() => launchDeleteUser(user)"
                      :icon="'trash'"
                      :variant="'none'"
                      :custom_class="`ml-1`"
                    >
                    </ButtonSmall>
                    <!-- <b-button
                      class="act-button ml-1 mb-1"
                      size="sm"
                      v-b-tooltip.v-secondary.noninteractive="
                        $t('toolbar.acts.removeAttendee')
                      "
                      @click="launchDeleteUser(user)"
                    >
                      <b-icon-x-circle></b-icon-x-circle>
                    </b-button> -->
                  </div>
                </b-td>
                <b-modal
                  :id="`modal-support-${user.id}`"
                  :title="`${$t('toolbar.acts.editAttendee')} ${
                    user.professional ? '' : $t('toolbar.acts.external')
                  }`"
                  size="lg"
                  hide-footer
                >
                  <SupportForm
                    :SupportTypes="SupportTypes"
                    :identifierTypes="identifierTypes"
                    :Support="user"
                    :act_id="act.id"
                    :allows_crud="allows_crud"
                    @updated="slotUpdateSupport"
                  ></SupportForm>
                </b-modal>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </div>

      <div class="act-section">
        <!-- Insertar Aquí -->
        <div class="section-title-comments mb-3">
          <ButtonMedium
            v-if="allows_crud && !selectedActTypeIsInstitutional"
            :tooltip_text="``"
            :text_button="$t('toolbar.acts.addAspect')"
            :click_button="() => $bvModal.show('modal-add-aspects')"
            :icon="'plus'"
            :variant="'primary'"
            :custom_class="``"
          >
          </ButtonMedium>
          <div class="custom-margin">
            <h4 class="title-comments-header mb-0">
              {{
                ActTypes.find((x) => x.id == act.act_type).name.toUpperCase()
              }}
            </h4>
          </div>
        </div>
        <div class="info-grid mb-0">
          <div
            :class="[
              'info-row',
              { 'info-row--full': selectedActTypeIsInstitutional },
            ]"
          >
            <div class="info-label">
              {{
                selectedActTypeIsInstitutional
                  ? $t("reusable.common.date")
                  : $t("reusable.common.startDate")
              }}:
            </div>
            <div class="info-value">
              <span v-if="selectedActTypeIsInstitutional">{{
                act.start_date | toDate
              }}</span>
              <span v-else>{{ act.start_date | toDateTime }}</span>
            </div>
          </div>
          <div v-if="!selectedActTypeIsInstitutional" class="info-row">
            <div class="info-label">{{ $t("reusable.common.endDate") }}:</div>
            <div class="info-value">{{ act.end_date | toDateTime }}</div>
          </div>
        </div>

        <!-- <h4 class="subsection-title">
          {{ $t("toolbar.acts.meetingTable").toUpperCase() }}
        </h4> -->
        <div v-if="!selectedActTypeIsInstitutional" class="aspects-list">
          <template v-for="aspect in aspectsList">
            <div :key="aspect.id" class="aspect-item">
              <RenderVHtml
                :class="allows_crud ? 'w-95' : ''"
                class="aspect-text"
                :content="aspect.text"
              ></RenderVHtml>
              <div v-if="allows_crud">
                <ButtonSmall
                  :tooltip_text="$t('toolbar.acts.editAspect')"
                  :text_button="``"
                  :click_button="
                    () => $bvModal.show(`edit-aspect-modal-${aspect.id}`)
                  "
                  :icon="'square'"
                  :variant="'none'"
                  :custom_class="`ml-1 mb-1`"
                >
                </ButtonSmall>
                <!-- <b-button
                  class="act-button ml-1 mb-1"
                  size="sm "
                  @click="$bvModal.show(`edit-aspect-modal-${aspect.id}`)"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('toolbar.acts.editAspect')
                  "
                >
                  <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
                </b-button> -->
                <ButtonSmall
                  :tooltip_text="$t('toolbar.acts.deleteAspect')"
                  :text_button="``"
                  :click_button="() => deleteAspect(aspect.id)"
                  :icon="'trash'"
                  :variant="'none'"
                  :custom_class="`ml-1 mb-1`"
                >
                </ButtonSmall>
                <!-- <b-button
                  class="act-button ml-1 mb-1"
                  size="sm"
                  @click="deleteAspect(aspect.id)"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('toolbar.acts.deleteAspect')
                  "
                >
                  <b-icon-x-circle></b-icon-x-circle>
                </b-button> -->
                <ContainerRichTextKlv3
                  :id_modal="`edit-aspect-modal-${aspect.id}`"
                  :title_modal="$t('reusable.common.edit')"
                  :size_modal="`lg`"
                  :object_rich_text="aspect"
                  :content_rich_text="aspect.text"
                  :show_last_modification="true"
                  :permit_blank="true"
                  :custom_cutoff_date="'2026-01-15T19:00:00.000Z'"
                  @save="(content) => updateAspect(aspect, content)"
                  @close="$bvModal.hide(`edit-aspect-modal-${aspect.id}`)"
                >
                </ContainerRichTextKlv3>
                <!-- <b-modal
                  :id="`edit-aspect-modal-${aspect.id}`"
                  :title="$t('reusable.common.edit')"
                  size="lg"
                  hide-footer
                >
                  <NewRichTextEditor
                    :Object="aspect"
                    :Text="aspect.text"
                    @save="updateAspect"
                    @close="$bvModal.hide(`edit-aspect-modal-${aspect.id}`)"
                  ></NewRichTextEditor>
                </b-modal> -->
              </div>
            </div>
          </template>
          <!-- <template v-for="aspect_type in selectedAspectTypes">
            <div :key="`aspect_type-${aspect_type.id}`" class="flex-col">
              <div>{{ aspect_type.text }}</div>
            </div>
            <template
              v-for="aspect in selectedAspects.filter(
                (x) => x.aspect_type == aspect_type.id
              )"
            >
              <div
                :key="`aspect-${aspect.id}`"
                class="flex-row align-items-center"
              >
                <div class="items-text">{{ aspect.text }}</div>
                <div v-if="allows_crud" class="user-buttons">
                  <b-button
                    class="act-button ml-1 mb-1"
                    size="sm"
                    @click="slotRemoveAspect(aspect.id)"
                  >
                    <b-icon-x-circle></b-icon-x-circle>
                  </b-button>
                </div>
              </div>
            </template>
          </template> -->
          <!-- <div class="flex-col" v-if="otherAspects.length > 0">
            <div>Otros</div>
          </div>
          <template v-for="aspect in otherAspects">
            <div
              :key="`aspect-${aspect.id}`"
              class="flex-row align-items-center"
            >
              <div class="items-text">{{ aspect.text }}</div>
              <div v-if="allows_crud" class="user-buttons">
                <b-button
                  class="act-button ml-1 mb-1"
                  size="sm"
                  @click="slotRemoveAspect(aspect.id)"
                >
                  <b-icon-x-circle></b-icon-x-circle>
                </b-button>
              </div>
            </div>
          </template> -->
        </div>
        <!-- <ButtonMedium
          v-if="allows_crud"
          :tooltip_text="``"
          :text_button="$t('toolbar.acts.addAspect')"
          :click_button="() => $bvModal.show('modal-add-aspects')"
          :icon="'plus'"
          :variant="'primary'"
          :custom_class="`mt-2`"
        >
        </ButtonMedium> -->
        <!-- <b-button
          v-if="allows_crud"
          class="act-button"
          size="sm mt-1"
          v-b-tooltip.v-secondary.noninteractive="$t('toolbar.acts.addAspect')"
          @click="$bvModal.show('modal-add-aspects')"
        >
          <b-icon-file-plus></b-icon-file-plus>Agregar Aspectos
        </b-button> -->
      </div>
    </div>

    <div class="act-content">
      <div v-if="!selectedActTypeIsInstitutional" class="act-section">
        <h4 class="section-title">
          {{ $t("toolbar.acts.treatedAspectsAndAgreements") }}
        </h4>
        <div>
          <div class="agreements-list">
            <!-- <template v-for="aspect_type in selectedAspectTypes">
          <div :key="`aspect_type-${aspect_type.id}`" class="flex-col">
            <div>{{ aspect_type.text }}</div>
          </div>
          <template
            v-for="aspect in selectedAspects.filter(
              (x) => x.aspect_type == aspect_type.id
            )"
          >
            <AspectAgreement
              :key="`aspect-${aspect.id}`"
              :act_id="act.id"
              :aspect_id="aspect.id"
              :Aspects="Aspects"
              :FulfillTypes="FulfillTypes"
              :allows_crud="allows_crud"
            >
            </AspectAgreement>
          </template>
        </template> -->
            <template v-for="aspect in aspectsList">
              <!-- <div :key="aspect.id">
          </div> -->
              <AspectAgreement
                class="aspect-container"
                :key="`aspect-${aspect.id}`"
                :Act="Act"
                :act_id="act.id"
                :aspect_id="aspect.id"
                :Aspects="aspectsList"
                :FulfillTypes="FulfillTypes"
                :allows_crud="allows_crud"
              >
              </AspectAgreement>
            </template>
            <!-- <template v-if="otherAspects.length > 0">
          <div class="flex-col">
            <div>Otros</div>
          </div>
        </template>
        <template v-for="aspect in otherAspects">
          <AspectAgreement
            :key="`aspect-${aspect.id}`"
            :act_id="act.id"
            :aspect_id="aspect.id"
            :Aspects="Aspects.concat(other_aspects)"
            :FulfillTypes="FulfillTypes"
            :allows_crud="allows_crud"
          >
          </AspectAgreement>
        </template> -->
          </div>
        </div>
      </div>

      <div class="act-section">
        <div class="section-title-comments mb-3">
          <ButtonMedium
            :tooltip_text="``"
            :text_button="$t('toolbar.acts.addComment')"
            :click_button="() => $bvModal.show('modal-add-comment')"
            :icon="'plus'"
            :variant="'primary'"
            :custom_class="``"
          >
          </ButtonMedium>
          <div class="custom-margin">
            <h4 class="title-comments-header mb-0">
              {{ $t("toolbar.acts.comments") }}
            </h4>
          </div>
          <div class="comments-header-actions">
            <span :class="!count_comment ? 'hide-comment' : ''" class="mr-2">
              <strong> {{ $t("toolbar.acts.commentsListUpdated") }} </strong>
            </span>

            <ButtonSmall
              :tooltip_text="$t('toolbar.acts.reloadComments')"
              :text_button="``"
              :click_button="fetchActComment"
              :icon="'counterclockwise'"
              :variant="'none'"
              :custom_class="``"
            >
            </ButtonSmall>
          </div>
        </div>
        <div class="comments-container">
          <div class="comments-list">
            <template v-if="commentsList.length > 0">
              <template v-for="comment in commentsList">
                <ActComments
                  :key="comment.id"
                  :Comment="comment"
                  :allows_crud="allows_crud"
                  @delete_comment="deleteComment"
                  @update_comment="updateComment"
                >
                </ActComments>
              </template>
            </template>
            <div v-else class="no-comments-message">
              {{ $t("toolbar.acts.noComments") }}
            </div>
          </div>

          <!-- <div class="comments-footer-actions">
            <ButtonMedium
              :tooltip_text="``"
              :text_button="$t('toolbar.acts.addComment')"
              :click_button="() => $bvModal.show('modal-add-comment')"
              :icon="'plus'"
              :variant="'primary'"
              :custom_class="``"
            >
            </ButtonMedium>
          </div> -->
        </div>
      </div>

      <div class="act-section">
        <!-- <div class="act-header">APOYO RECIBIDO PARA LA GESTIÓN PEDAGÓGICA</div>
        <div class="agreement-container">
          <div class="support-container">
            <template v-for="support in supports">
              <ActSupport
                :Support="support"
                :SupportTypes="SupportTypes"
                :key="support.id"
                :allows_crud="allows_crud"
                @updated="slotUpdatedSupport"
                @deleted="slotDeleteSupport"
              ></ActSupport>
            </template>
            <b-button
              v-if="allows_crud"
              class="act-button"
              size="sm mt-1"
              @click="$bvModal.show('modal-support')"
            >
              <b-icon-file-plus></b-icon-file-plus>Agregar Apoyo
            </b-button>
          </div>
        </div> -->

        <h4 class="section-title">{{ $t("toolbar.acts.attachedFiles") }}</h4>
        <ActFiles :Act="act" :allows_crud="allows_crud"></ActFiles>
      </div>
      <ButtonMedium
        v-if="allows_crud"
        :tooltip_text="``"
        :text_button="
          $t('reusable.common.saveTooltip', {
            entity: $getVisibleNames(
              'manual.acta_de_comite',
              false,
              'Acta de Comité'
            ),
          })
        "
        :click_button="save"
        :icon="''"
        :variant="'primary'"
        :custom_class="`mt-1 mb-3`"
      >
      </ButtonMedium>
    </div>
    <!-- <b-button v-if="allows_crud" class="act-button mt-1" @click="save">
      <b-icon-file-plus></b-icon-file-plus>Guardar Acta
    </b-button> -->

    <ContainerRichTextKlv3
      :id_modal="`modal-add-aspects`"
      :title_modal="$t('toolbar.acts.createAspects')"
      :size_modal="`lg`"
      :object_rich_text="{}"
      :content_rich_text="''"
      :show_last_modification="true"
      :permit_blank="true"
      :custom_cutoff_date="'2026-01-15T19:00:00.000Z'"
      :allow_list_mode="true"
      @save="(content) => createAspect(content)"
      @save-list="(contents) => createAspects(contents)"
      @close="$bvModal.hide(`modal-add-aspects`)"
    >
    </ContainerRichTextKlv3>
    <!-- Modals -->
    <!-- <b-modal
      id="modal-add-aspects"
      :title="$t('toolbar.acts.createAspects')"
      size="lg"
      hide-footer
    >
      <NewRichTextEditor
        @save="createAspect"
        @close="$bvModal.hide('modal-add-aspects')"
      ></NewRichTextEditor> -->
    <!-- ok-only
      @ok="slotUpdateAct" -->
    <!-- <AspectsSelector
        :AspectTypes="AspectTypes"
        :Aspects="Aspects"
        :ActAspects="act_aspect_ids"
        :allows_crud="allows_crud"
        @selected="slotSelectedAspects"
        @created="slotCreatedAspect"
      ></AspectsSelector> -->
    <!-- </b-modal> -->
    <ContainerRichTextKlv3
      :id_modal="`modal-add-comment`"
      :title_modal="$t('toolbar.acts.createComment')"
      :size_modal="`lg`"
      :object_rich_text="{}"
      :content_rich_text="''"
      :show_last_modification="true"
      :permit_blank="true"
      :custom_cutoff_date="'2026-01-15T19:00:00.000Z'"
      :allow_list_mode="true"
      @save="(content) => createComment(content)"
      @save-list="(contents) => createComments(contents)"
      @close="$bvModal.hide(`modal-add-comment`)"
    >
    </ContainerRichTextKlv3>
    <!-- <b-modal
      id="modal-add-comment"
      :title="$t('toolbar.acts.createComment')"
      size="lg"
      hide-footer
    >
      <NewRichTextEditor
        @save="createComment"
        @close="$bvModal.hide('modal-add-comment')"
      ></NewRichTextEditor>
    </b-modal> -->
    <b-modal
      id="modal-support"
      :title="$t('toolbar.acts.addExternalAttendee')"
      size="lg"
      hide-footer
    >
      <SupportForm
        :SupportTypes="SupportTypes"
        :act_id="act.id"
        :allows_crud="allows_crud"
        :identifierTypes="identifierTypes"
        @created="slotCreatedSupport"
      ></SupportForm>
    </b-modal>
    <b-modal
      id="modal-users"
      :title="$t('toolbar.acts.manageAttendees')"
      size="xl"
      @close="slotUsersClosed"
      @hide="
        () => {
          selected_users = [];
        }
      "
    >
      <NewGenericBTable
        :fields="userFields"
        :url="'/authentication/user/'"
        :pre_filter="preFilterUsers"
        :search_filter="true"
        :columns_display="true"
        :pagination="10"
      >
        <template #cell(name)="row">
          {{ row.item.first_name }} {{ row.item.last_name }}
        </template>

        <template #cell(selected)="row">
          <div class="d-flex">
            <b-checkbox
              class="ml-auto mr-auto"
              :checked="selected_users.some((x) => x.id == row.item.id)"
              @change="toggleUserSelection(row.item)"
            ></b-checkbox>
          </div>
        </template>
        <template #cell(role)="row">
          {{ getRole(row.item) }}
        </template>
      </NewGenericBTable>

      <template #modal-footer>
        <b-button size="sm" variant="secondary" @click="closeSelectedUsers">
          {{ $t("reusable.common.cancel") }}
        </b-button>
        <b-button size="sm" variant="primary" @click="addSelectedUsers">
          {{ $t("toolbar.acts.incorporate") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import {
  // generateUniqueId,
  toast,
} from "@/utils/utils";

export default {
  name: "ActComponent",
  components: {
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    // AspectsSelector: () => import("./AspectsSelector"),
    AspectAgreement: () => import("./AspectAgreement"),
    // ActSupport: () => import("./ActSupport"),
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    NewGenericBTable: () => import("@/components/reusable/NewGenericBTable"),
    ActFiles: () => import("./ActFiles"),
    SupportForm: () => import("./SupportForm"),
    ActComments: () => import("./ActComments"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
  },
  props: {
    Act: {
      type: Object,
      required: true,
    },
    // AspectTypes: {
    //   type: Array,
    //   required: true,
    // },
    Aspects: {
      type: Array,
      required: true,
    },
    FulfillTypes: {
      type: Array,
      required: true,
    },
    ActTypes: {
      type: Array,
      required: true,
    },
    identifierTypes: {
      type: Array,
      required: true,
    },
    SupportTypes: {
      type: Array,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      act: this.Act,
      act_aspect_ids: [],
      users_list: [],
      act_comments: [],
      count_comment: false,
      // other_aspects: [],
      aspects: [],
      supports: [],
      selected_users: [],
      roles: [],
    };
  },
  computed: {
    ...mapGetters({
      campuses: names.CAMPUSES,
      egressProfiles: names.EGRESS_PROFILES,
      carrers: names.CAREERS,
      users: names.USERS,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      matters: names.MATTERS,
      sections: names.SECTIONS,
      periods: names.PERIODS,
    }),
    creatorLabel() {
      // El creador siempre puede editar/eliminar el acta y sus adjuntos.
      // created_by viene como email; el nombre sale de users_list (act_addable_users).
      // Sin creador, el backend da la edición a los superusuarios.
      if (!this.act.created_by) return this.$t("toolbar.acts.noCreator");
      const creator = this.users_list.find((x) => x.email == this.act.created_by);
      if (!creator) return this.act.created_by;
      const name = `${creator.first_name} ${creator.last_name}`.trim();
      return name ? `${name} (${creator.email})` : creator.email;
    },
    selectedActTypeIsInstitutional() {
      if (!this.act.act_type) return false;
      const actType = this.ActTypes.find((x) => x.id == this.act.act_type);
      return actType ? actType.is_institutional : false;
    },
    getPeriod() {
      const period = this.periods.find((x) => x.id == this.act.period);
      return period ? period.name : "";
    },
    egressProfile() {
      return this.egressProfiles.find((x) => x.id == this.act.egress_profile);
    },
    campus() {
      return this.campuses.find((x) => x.id == this.act.campus);
    },
    career() {
      if (!this.egressProfile) return null;
      return this.carrers.find((x) => x.id == this.egressProfile.career);
    },
    usersToRemove() {
      const user_support = this.supports.map((x) => x.professional);
      return user_support.filter((x) => x !== null);
    },
    userFields() {
      return [
        {
          key: "selected",
          label: "",
          display_column: true,
          thStyle: "width:25px",
          tdStyle: "width:25px",
        },
        {
          key: "name",
          sortable: false,
          label: this.$t("toolbar.acts.name"),
          display_column: true,
        },
        {
          key: "user_data",
          label: this.$t("toolbar.acts.identifier"),
          sortable: false,
          display_column: true,
          formatter: (value) => {
            return value ? value.identifier : "";
          },
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "role",
          label: this.$t("toolbar.acts.role"),
          sortable: false,
          display_column: true,
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "email",
          label: this.$t("toolbar.acts.email"),
          sortable: false,
          display_column: true,
          thClass: "text-right",
          tdClass: "text-right",
        },
      ];
    },
    preFilterUsers() {
      const excludedIds = this.usersToRemove;
      const groups = [
        "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
        "DIRECTIVOS FACULTAD O ESCUELA",
        "DIRECTORES DE CARRERA",
        "PROFESORES",
        "VISITANTES",
        "ADMINISTRATIVOS INSTRUCCIONALES",
      ];

      let filters = [];

      if (groups.length > 0) {
        filters.push(`groups__name__in=${groups.join(",")}`);
      }

      if (excludedIds.length > 0) {
        filters.push(`id__exclude__in=${excludedIds.join(",")}`);
      }

      return filters.join("&");
    },
    actUsers() {
      const supports = this.supports.filter((x) => (x.act = this.act.id));
      supports.forEach((support_user) => {
        if (support_user.professional) {
          const user = this.users_list.find(
            (x) => x.id == support_user.professional
          );
          if (user) {
            support_user.first_name = user.first_name;
            support_user.last_name = user.last_name;
            support_user.email = user.email;
            if (user.user_data) {
              support_user.identifier_type = user.user_data.identifier_type;
              support_user.identifier = user.user_data.identifier;
            }
          }
        }
      });
      // this.act.professors.forEach((user_id) => {
      //   const user = this.users.find((x) => x.id == user_id);
      //   if (user) list.push(user);
      // });
      return supports;
    },
    // actUsers() {
    //   let list = [];
    //   this.act.professors.forEach((user_id) => {
    //     const user = this.uaspectsListsers.find((x) => x.id == user_id);
    //     if (user) list.push(user);
    //   });
    //   return list;
    // },
    // selectedAspectTypes() {
    //   let list = [];
    //   this.act_aspect_ids.forEach((aspect_id) => {
    //     const aspect = this.Aspects.find((x) => x.id == aspect_id);
    //     if (aspect && aspect.aspect_type) {
    //       const aspect_type = this.AspectTypes.find(
    //         (x) => x.id == aspect.aspect_type
    //       );
    //       if (list.findIndex((x) => x.id == aspect_type.id) == -1)
    //         list.push(aspect_type);
    //     }
    //   });
    //   list = list.sort(function (a, b) {
    //     if (a.order > b.order) return 1;
    //     if (a.order < b.order) return -1;
    //     return 0;
    //   });
    //   return list;
    // },
    aspectsList() {
      let list = [];
      if (this.act) {
        list = this.aspects.filter((x) => x.act == this.act.id);
      }
      return list;
    },
    commentsList() {
      let list = [];
      if (this.act) {
        list = this.act_comments.filter((x) => x.act == this.act.id);
      }
      return list.sort(function (a, b) {
        if (a.creation_date < b.creation_date) return 1;
        if (a.creation_date > b.creation_date) return -1;
        return 0;
      });
    },
    // selectedAspects() {
    //   let list = [];
    //   this.act_aspect_ids.forEach((aspect_id) => {
    //     const aspect = this.Aspects.find((x) => x.id == aspect_id);
    //     if (aspect) list.push(aspect);
    //   });
    //   return list;
    // },
    filteredMatters() {
      return this.egress_profiles_matters.filter(
        (x) =>
          x.egress_profile == this.act.egress_profile &&
          x.plan_level == this.act.level
      );
    },
    filteredSections() {
      let list = [];
      this.filteredMatters.forEach((matter) => {
        let sections = this.sections.filter(
          (x) => x.egress_profile_matter == matter.id
        );
        list = list.concat(sections);
      });
      return list;
    },
  },
  methods: {
    redirectEgressProfile() {
      if (!this.act || !this.act.egress_profile) return;
      const url = this.$router.resolve({
        name: "EgressProfileView",
        params: {
          egress_profile_id: this.act.egress_profile,
        },
      }).href;
      window.open(url, "_blank");
    },
    fetchSupports() {
      this.$restful
        .GetAll(`/cideu/support/?act=${this.act.id}`)
        .then((response) => {
          this.supports = response;
        });
    },
    slotSelectedAspects(selected_aspects) {
      selected_aspects.forEach((id) => {
        const index = this.act_aspect_ids.find((x) => x == id);
        if (!index) this.act_aspect_ids.push(id);
      });
    },
    createAspect(text) {
      if (text != "")
        this.$restful
          .Post(`/cideu/aspect/`, {
            act: this.act.id,
            text: text,
            order: this.aspects.length,
          })
          .then((response) => {
            this.aspects.push(response);
          });
      else toast(this.$t("toolbar.acts.cannotSaveIfEmpty"));
    },
    // Modo lista: crea un aspecto por línea, a continuación de los existentes
    createAspects(texts) {
      const items = texts.map((text, index) => ({
        act: this.act.id,
        text: text,
        order: this.aspects.length + index,
      }));
      this.$restful
        .Post(`/cideu/aspect/bulk-create/`, items)
        .then((response) => {
          response.forEach((aspect) => this.aspects.push(aspect));
        });
    },
    updateAspect(object, text) {
      if (text != "")
        this.$restful
          .Patch(`/cideu/aspect/${object.id}/`, { text: text })
          .then((response) => {
            const index = this.aspects.findIndex((b) => b.id == object.id);
            if (index != -1) this.aspects.splice(index, 1, response);
            this.$bvModal.hide(
              `edit-bibliographic-resource-modal-${object.id}`
            );
          });
      else toast(this.$t("toolbar.acts.cannotSaveIfEmpty"));
    },
    deleteAspect(id) {
      this.$swal({
        title: this.$t("toolbar.acts.deleteAspectConfirmation"),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$restful.Delete(`/cideu/aspect/${id}/`).then(() => {
            const index = this.aspects.findIndex((b) => b.id == id);
            if (index != -1) this.aspects.splice(index, 1);
          });
        }
      });
    },
    slotUpdateAct() {
      this.$restful
        .Patch(`/cideu/act/${this.act.id}/`, {
          aspects: this.act_aspect_ids,
        })
        .then((response) => {
          this.$emit("updated", response);
          toast(this.$t("toolbar.acts.actUpdatedSuccessfully"));
        });
    },
    createComment(text) {
      if (text != "")
        this.$restful
          .Post(`/cideu/act-comment/`, {
            act: this.act.id,
            comment: text,
          })
          .then((response) => {
            this.act_comments.push(response);
          });
      else toast(this.$t("toolbar.acts.cannotSaveIfEmpty"));
    },
    // Modo lista: crea un comentario por línea
    createComments(texts) {
      const items = texts.map((text) => ({
        act: this.act.id,
        comment: text,
      }));
      this.$restful
        .Post(`/cideu/act-comment/bulk-create/`, items)
        .then((response) => {
          response.forEach((comment) => this.act_comments.push(comment));
        });
    },
    updateComment({ id, comment }) {
      this.$restful
        .Patch(`/cideu/act-comment/${id}/`, { comment })
        .then((response) => {
          const index = this.act_comments.findIndex((b) => b.id == id);
          if (index != -1) this.$set(this.act_comments, index, response);
        });
    },
    deleteComment(id) {
      this.$swal({
        title: this.$t("toolbar.acts.deleteCommentConfirmation"),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$restful.Delete(`/cideu/act-comment/${id}/`).then(() => {
            const index = this.act_comments.findIndex((b) => b.id == id);
            if (index != -1) this.act_comments.splice(index, 1);
          });
        }
      });
    },
    getIdentifierType(id) {
      const identifier = this.identifierTypes.find((x) => x.id == id);
      if (identifier) return identifier.identifier_name;
      return "";
    },
    getRole(user) {
      if (user.is_superuser == true) return this.$t("toolbar.acts.superUser");
      const role = this.roles.find((x) => x.id == user.role);
      return role ? role.position_name : "";
    },
    // slotRemoveAspect(aspect_id) {
    //   this.$restful
    //     .Get(`/cideu/agreement/?act=${this.Act.id}&aspect=${aspect_id}`)
    //     .then((agreements) => {
    //       if (agreements.length > 0) {
    //         this.$swal({
    //           title: "¿Está seguro de que desea eliminar al Aspecto?",
    //           text: "Contiene acuerdos que se eliminarán!",
    //           type: "warning",
    //           showCancelButton: true,
    //         }).then((result) => {
    //           if (result.value) {
    //             agreements.forEach((agreement) => {
    //               this.deleteAgreement(agreement);
    //             });
    //             this.removeAspect(aspect_id);
    //           }
    //         });
    //       } else {
    //         this.removeAspect(aspect_id);
    //       }
    //     });
    // },
    // removeAspect(aspect_id) {
    //   let index = this.act_aspect_ids.findIndex((x) => x == aspect_id);
    //   if (index != -1) {
    //     this.act_aspect_ids.splice(index, 1);
    //     this.patchAct({
    //       aspects: this.act_aspect_ids,
    //     });
    //   }
    //   index = this.other_aspects.findIndex((x) => x.id == aspect_id);
    //   if (index != -1) {
    //     this.$restful.Delete(`/cideu/aspect/${aspect_id}/`).then(() => {
    //       this.other_aspects.splice(index, 1);
    //       toast("Aspecto eliminado.");
    //     });
    //   }
    // },
    save() {
      if (!isNaN(this.act.id)) this.updateAct();
    },
    updateAct() {
      this.$restful
        .Put(`/cideu/act/${this.act.id}/`, this.act)
        .then((response) => {
          this.$emit("updated", response);
          toast(this.$t("toolbar.acts.actUpdatedSuccessfully"));
        });
    },
    slotCreatedSupport(support) {
      this.supports.push(support);
      this.$bvModal.hide("modal-support");
    },
    slotUpdateSupport(support) {
      let index = this.supports.findIndex((x) => x.id == support.id);
      if (index != -1) this.supports.splice(index, 1, support);
      else this.supports.push(support);
      this.$bvModal.hide("modal-support-" + support.id);
    },
    // slotUpdatedSupport(support) {
    //   const index = this.supports.find((x) => x.id == support.id);
    //   if (index != -1) {
    //     this.supports.splice(index, 1, support);
    //   } else {
    //     this.supports.push(support);
    //   }
    // },
    slotUsersClosed() {
      this.selected_users = [];
      this.save();
    },
    toggleUserSelection(user) {
      const index = this.selected_users.findIndex((x) => x.id == user.id);
      if (index != -1) {
        this.selected_users.splice(index, 1);
      } else {
        this.selected_users.push(user);
      }
    },
    addSelectedUsers() {
      if (this.selected_users.length == 0) {
        toast(this.$t("toolbar.acts.mustSelectAtLeastOneUser"));
        return;
      }

      this.selected_users.forEach((user) => {
        const index = this.supports.findIndex((x) => x.professional == user.id);
        let user_identifier = null;
        let user_identifier_type = null;
        if (user.user_data) {
          user_identifier = user.user_data.identifier;
          user_identifier_type = user.user_data.identifier_type;
        }
        if (index == -1) {
          this.$restful
            .Post(`/cideu/support/`, {
              professional: user.id,
              moment: 1,
              act: this.act.id,
              occupation: "",
              identifier: user_identifier,
              identifier_type: user_identifier_type,
            })
            .then((response) => {
              this.supports.push(response);
            });
        } else {
          toast(this.$t("toolbar.acts.userAlreadyInList"));
        }
      });

      this.selected_users = [];
      this.$bvModal.hide("modal-users");
    },
    closeSelectedUsers() {
      this.selected_users = [];
      this.$bvModal.hide("modal-users");
    },
    // slotSelectedUsers(users) {
    //   users.forEach((user) => {
    //     const index = this.act.professors.findIndex((x) => x == user.id);
    //     if (index == -1) this.act.professors.push(user.id);
    //     else toast("El usuario seleccionado ya está en la lista.");
    //   });
    // },
    launchDeleteUser(user) {
      this.$swal({
        title: this.$t("toolbar.acts.deleteAttendeeConfirmation"),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.deleteUser(user);
        }
      });
    },
    deleteUser(support) {
      const index = this.supports.findIndex((x) => x.id == support.id);
      if (index != -1)
        this.$restful.Delete(`/cideu/support/${support.id}/`).then(() => {
          this.supports.splice(index, 1);
        });
    },
    // launchDeleteUser(user) {
    //   this.$swal({
    //     title: "¿Está seguro de que desea eliminar al Docente?",
    //     text: "¡Esta acción no se podrá revertir!",
    //     type: "warning",
    //     showCancelButton: true,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.deleteUser(user);
    //     }
    //   });
    // },
    // deleteUser(user) {
    //   const index = this.act.professors.findIndex((x) => x == user.id);
    //   if (index != -1) this.act.professors.splice(index, 1);
    // },
    // slotDeleteSupport(support) {
    //   const index = this.supports.findIndex((x) => x.id == support.id);
    //   if (index != -1) {
    //     this.supports.splice(index, 1);
    //   }
    // },
    // slotCreatedAspect(aspect) {
    //   this.act_aspect_ids.push(aspect.id);
    //   this.other_aspects.push(aspect);
    //   this.patchAct({
    //     aspects: this.act_aspect_ids,
    //   });
    // },
    patchAct(item) {
      this.$restful
        .Patch(`/cideu/act/${this.act.id}/`, item)
        .then((response) => {
          this.$emit("updated", response);
          toast(this.$t("toolbar.acts.actUpdatedSuccessfully"));
        });
    },
    deleteAgreement(agreement) {
      this.$restful.Delete(`/cideu/agreement/${agreement.id}/`).then(() => {
        toast(this.$t("toolbar.acts.agreementDeleted"));
      });
    },
    fetchAspects() {
      this.$restful
        .GetAll(`/cideu/aspect/?act=${this.act.id}`)
        .then((response) => {
          this.aspects = response;
        });
    },
    fetchActComment() {
      this.count_comment = true;
      this.$restful
        .GetAll(`/cideu/act-comment/?act=${this.act.id}`)
        .then((response) => {
          this.act_comments = response;
          this.count_comment = false;
          // toast("Comentarios Actualizados.");
        });
    },
    debouncefetchComment() {
      this.timeout = setTimeout(() => {
        this.fetchActComment();
      }, 15000);
    },
  },
  mounted() {
    this.debouncefetchComment();
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
  watch: {
    act_comments: {
      handler() {
        if (this.timeout) clearTimeout(this.timeout);
        this.debouncefetchComment();
      },
    },
  },
  created() {
    this.fetchSupports();
    this.fetchAspects();
    this.fetchActComment();
    this.$restful.GetAll(`/teaching/roles/`).then((response) => {
      this.roles = response;
    });
    if (this.act && this.act.egress_profile)
      this.$store.dispatch(names.FETCH_EGRESS_PROFILE, this.act.egress_profile);
    // .then((ep) => {
    // this.$store
    //   .dispatch(names.FETCH_MATTERS, { egress_profile_id: ep.id })
    //   .then((matters) => {
    //     matters.forEach((matter) => {
    //       this.$store.dispatch(names.FETCH_SECTIONS, {
    //         matter_id: matter.id,
    //       });
    //     });
    //   });
    // });
    this.$restful.Get(`/cideu/act_addable_users/`).then((response) => {
      this.users_list = response;
    });
    // this.Act.professors.forEach((user_id) => {
    // this.$store.dispatch(names.FETCH_USER, user_id);
    // });
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
/* Documento principal */
.act-document {
  background: var(--kl-surface);
  border: 1px solid var(--kl-table-border);
  margin: 1rem auto;
}

.act-title {
  background: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
  padding: var(--kl-space-2) var(--kl-space-5);
  text-align: center;
  font-size: var(--kl-fs-title-md);
  font-weight: var(--kl-fw-bold);
  letter-spacing: 1px;
  border-bottom: 1px solid var(--kl-table-border);
}

.act-content {
  padding: 0 var(--kl-space-4);
}

/* Secciones */
.act-section {
  background: var(--kl-surface);
  padding: var(--kl-space-2);
  margin-bottom: var(--kl-space-6);
}

.section-title {
  color: var(--kl-text-heading);
  padding: var(--kl-space-3) 0rem;
  font-size: var(--kl-fs-title-sm);
  font-weight: var(--kl-fw-semibold);
  margin: -1.5rem 0rem 0rem 0rem;
}

.section-title-comments {
  display: flex;
  align-items: center;
  justify-content: left;
  position: relative;
  color: var(--kl-text-heading);
  padding: var(--kl-space-3) 0rem;
}
.title-comments-header {
  font-size: var(--kl-fs-title-sm) !important;
  font-weight: var(--kl-fw-semibold);
}

.custom-margin {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.subsection-title {
  padding: var(--kl-space-2) var(--kl-space-4);
  font-size: var(--kl-fs-title-sm);
  font-weight: var(--kl-fw-semibold);
  margin: 1rem 0 0rem 0;
}

/* Grid de información */
.info-row--full {
  grid-column: 1 / -1;
}
.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: var(--kl-space-4);
  border-top: 1px solid var(--kl-table-border);
  border-left: 1px solid var(--kl-table-border);
}

.info-row {
  display: flex;
  border-right: 1px solid var(--kl-table-border);
  border-bottom: 1px solid var(--kl-table-border);
  background: var(--kl-surface-muted);
}

.info-label {
  background: var(--kl-table-header-bg);
  color: var(--kl-table-header-text);
  padding: var(--kl-space-2) var(--kl-space-4);
  font-weight: var(--kl-fw-semibold);
  min-width: 200px;
  display: flex;
  align-items: center;
}
.info-label1 {
  background: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
  padding: var(--kl-space-2) var(--kl-space-4);
  font-weight: var(--kl-fw-semibold);
  min-width: 200px;
  display: flex;
  align-items: center;
}

.info-value {
  padding: var(--kl-space-2) var(--kl-space-4);
  flex: 1;
  background: var(--kl-surface);
  display: flex;
  align-items: center;
}

/* Enlaces */
.link-text {
  color: var(--kl-text-link);
  cursor: pointer;
  text-decoration: none;
}

.link-text:hover {
  color: var(--kl-color-primary-hover);
  text-decoration: underline;
}

/* Tablas */
.table-container {
  overflow: hidden;
}

.formal-table {
  margin-bottom: 0;
}

.formal-table >>> .formal-thead th {
  background: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary) !important;
  font-weight: var(--kl-fw-bold);
  text-align: center;
  vertical-align: middle;
  padding: var(--kl-space-3) var(--kl-space-2);
  font-size: var(--kl-table-header-fs);
}

.formal-table >>> tbody td {
  padding: var(--kl-space-3) var(--kl-space-2);
  vertical-align: middle;
  color: var(--kl-table-text);
  font-size: var(--kl-table-fs);
}

.formal-table >>> tbody tr:nth-child(even) {
  background: var(--kl-table-row-alt-bg);
}

.formal-table >>> tbody tr:hover {
  background: var(--kl-table-row-hover-bg);
}

/* Listas de aspectos */
.aspects-list {
  border: 1px solid var(--kl-table-border);
  border-top: none;
  padding: var(--kl-space-2);
  margin-bottom: var(--kl-space-4);
  background: var(--kl-surface);
}

.aspect-item {
  display: flex;
  align-items: flex-start;
  padding: var(--kl-space-3);
  border-bottom: 1px solid var(--kl-border-soft);
  margin-bottom: var(--kl-space-2);
}

.aspect-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.aspect-text {
  flex: 1;
  text-align: justify;
  line-height: var(--kl-lh-base);
}

/* Container de acuerdos */

.agreements-list {
  background: var(--kl-surface);
}

/* Comentarios */
.comments-container {
  padding: 0;
}

.comments-header-actions {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.comments-list {
  background: var(--kl-surface);
  min-height: 100px;
  max-height: 500px;
  overflow-y: auto;
  padding: 0.3rem;
}

@media print {
  .comments-list {
    max-height: none;
    overflow-y: visible;
  }
}

.no-comments-message {
  text-align: center;
  padding: var(--kl-space-5) var(--kl-space-4);
  color: var(--kl-text-muted);
  font-style: italic;
  background: var(--kl-surface-muted);
  border: 1px dashed var(--kl-table-border);
}

.comments-footer-actions {
  display: flex;
  justify-content: center;
}

.hide-comment {
  animation: hide 1s linear 2s 1 forwards;
}

@keyframes hide {
  to {
    opacity: 0;
  }
}

/* Botones de soporte */
.support-button {
  display: flex;
  width: 100%;
  justify-content: left;
}

/* Utilidades */
.w-95 {
  width: 95%;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

/* Responsive */
@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
  }

  .act-content {
    padding: 1rem;
  }
}
</style>